'use client';

import { c as _c } from "react/compiler-runtime";
import { Suspense } from 'react';
import { ConciergeForm } from '~/components/ConciergeForm';
import { ContactForm } from '~/components/ContactForm';
import type { FormSectionProps } from './FormSection.types';
const FormSection = t0 => {
  const $ = _c(2);
  const {
    slug
  } = t0;
  switch (slug) {
    case "concierge":
      {
        let t1;
        if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
          t1 = <Suspense fallback={null}><ConciergeForm /></Suspense>;
          $[0] = t1;
        } else {
          t1 = $[0];
        }
        return t1;
      }
    case "contact":
      {
        let t1;
        if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
          t1 = <Suspense fallback={null}><ContactForm /></Suspense>;
          $[1] = t1;
        } else {
          t1 = $[1];
        }
        return t1;
      }
    default:
      {
        return null;
      }
  }
};
export { FormSection };